import React, { useMemo } from 'react'
import { MilkProductionField } from '../style'
import { useFormContext, useWatch } from 'react-hook-form'
import { Form, Icon, Popup } from 'semantic-ui-react'
import { StyledLabelError } from './style'

const DieselPerCow:React.FC = () => {
  const { control, formState: { isSubmitted, errors }, clearErrors, setError } = useFormContext()
  
  const watchDieselConsumption = useWatch({ control, name: 'dieselConsumption' })
  const watchCowsNumber = useWatch({ control, name: 'cowsNumber' })

  const dieselConsPerCowPerYear = useMemo(() => {

    if(watchDieselConsumption && watchCowsNumber) {
      const dieselConsumption = Math.floor(parseFloat(watchDieselConsumption?.toString()?.replace(',', '.')) / watchCowsNumber)
      if(dieselConsumption > 100) {
        setError('dieselCowConsumption', { message: 'dieselCowConsumption' })
      } else {
        clearErrors('dieselCowConsumption')
      }
      return dieselConsumption
    }
        
    return 0
  }, [watchCowsNumber, watchDieselConsumption])

  return <Form.Field>
    <MilkProductionField>
      <label style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <div>{'Liter pro Kuh u. Jahr'}</div>
        {(dieselConsPerCowPerYear < 20 || dieselConsPerCowPerYear > 60) && <Popup
          content={'Der Dieselverbrauch pro Kuh und Jahr liegt außerhalb der normalen Bereiche von mind. 20 Liter und max. 60 Liter betragen.'}
          trigger={<Icon name='warning sign' color='yellow' style={{ fontSize: '1.2em' }}/> }
        />}
      </label>
      <div>{`${dieselConsPerCowPerYear} Liter pro Kuh u. Jahr`}</div>
    </MilkProductionField>
    {isSubmitted && errors?.dieselCowConsumption && <StyledLabelError
      prompt
      pointing={'above'}>{'Der Dieselverbrauch pro Färse und Jahr darf maximal 100 Liter betragen.'}
    </StyledLabelError>}
  </Form.Field>
}
export default DieselPerCow